export default __webpack_public_path__ + "static/media/Apple iPad Air (2020).6280aff1.png";